var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.estados,"item-text":"uf","item-value":"uf","no-data-text":"Nenhuma UF encontrada","label":"UF","dense":_vm.dense,"disabled":_vm.disabled,"loading":_vm.estadoLoading},model:{value:(_vm.ufModel),callback:function ($$v) {_vm.ufModel=$$v},expression:"ufModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }